import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Alert, message, Select } from 'antd';
import Ink from 'react-ink';

import {
	userInsert,
	userUpdate
} from '../../../modules/user';
import {
  schoolList
} from '../../../modules/school';

import './userdetails.css';

const FormItem = Form.Item;
const { Option } = Select;

class UserDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null,
      schoolList: null,
		}
	}

  componentDidMount = () => {
    if (!this.props.schoolListData) {
      this.getSchoolList();
    } else {
      this.setState({schoolList: this.props.schoolListData});
    }
  }
	
	handleSubmit = e => {
    const { data } = this.props;
		e.preventDefault();

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });
				if (values.password.length > 9) {
					this.props.form.setFields({
						password: {
							value: values.password,
							errors: [new Error('密碼太長（最多9個字元）')],
						}
					});
					this.setState({ loading: false }); 
				} else if (values.password.length < 6) {
					this.props.form.setFields({
						password: {
							value: values.password,
							errors: [new Error('密碼太短（最少6個字元）')],
						}
					});
					this.setState({ loading: false }); 
				} else {
					if (!data) {
						this.props.userInsert(values).then( 
							(res) => {
								message.success('學校帳戶新增成功！');
								this.setState({ loading: false, message: null });
								this.props.form.resetFields();
								this.props.callback();
							},
							(err) => {
								this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` }); 
							}
						);
					} else {
						this.props.userUpdate(values, data.id).then( 
							(res) => {
								message.success('學校帳戶編輯成功！');
								this.setState({ loading: false, message: null });
								this.props.form.resetFields();
								this.props.callback();
							},
							(err) => {
								this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` }); 
							}
						);
					}

				}
			}
		});
	}

	handleConfirmBlur = (e) => {
		const value = e.target.value;
		this.setState({ confirmDirty: this.state.confirmDirty || !!value });
	}

	compareToFirstPassword = (rule, value, callback) => {
		const form = this.props.form;
		if (value && value !== form.getFieldValue('password')) {
			callback('兩個輸入的密碼不一致！');
		} else {
			callback();
		}
	}

	validateToNextPassword = (rule, value, callback) => {
		const form = this.props.form;
		if (value && this.state.confirmDirty) {
			form.validateFields(['confirmpassword'], { force: true });
		}
		if (value && value !== "" && !value.match(/^[0-9a-zA-Z]+$/)) {
			callback('密碼只接受數字和字母!');
		}
		callback();
	}

  getSchoolList = () => {
    this.props.schoolList().then((res) => {
      this.setState({schoolList: res});
    })
  }

  constructSchoolOptions = () => {
    const { schoolList } = this.state;
    if (schoolList) {
      return schoolList.results.map((item, i) => <Option value={item._id}>{item.name_tc || item.name_en}</Option>);
    }
  }

	render() {
		const { loading, message } = this.state;
    const { data } = this.props;
		const { getFieldDecorator } = this.props.form;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

				<FormItem>
					{getFieldDecorator('email', {
						rules: [
							{ type: 'email', message: '這不是一個有效的電郵' },
							{ required: true, message: '請輸入電郵!' }
						],
						initialValue: (data && data.email) ? data.email : "" ,
					})(
					<Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="電郵" readOnly={(data) ? true : false} />
					)}
				</FormItem>

        <p className="passwordNote">選擇學校</p>
        <FormItem>
					{ getFieldDecorator('schoolId', {
						rules: [ { required: true, message: '請選擇學校！' } ],
						initialValue: (data && data.schoolId) ? data.schoolId : "",
					})(
					  <Select disabled={data && data.schoolId}>
            {
              this.constructSchoolOptions()
            }
            </Select>
					)}
				</FormItem>

				<p className="passwordNote">
					輸入6至9個字母或數字的密碼。
				</p>
				<FormItem>
					{getFieldDecorator('password', {
						rules: [
							{ required: true, message: '請輸入密碼!' },
							{ validator: this.validateToNextPassword }
						],
					})(
					<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密碼" />
					)}
				</FormItem>

				<FormItem>
					{getFieldDecorator('confirmpassword', {
						rules: [
							{ required: true, message: '請確認密碼!' },
							{ validator: this.compareToFirstPassword }
						],
					})(
					<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="確認密碼" onBlur={this.handleConfirmBlur} />
					)}
				</FormItem>			

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> 提交</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedUserDetailsModal  = Form.create()(UserDetails);

const mapStateToProps = state => ({
  schoolListData: state.school.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		userInsert,
		userUpdate,
    schoolList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedUserDetailsModal);